import React from 'react';
import {useLocation} from 'react-router-dom';

import HeaderRow1 from './HeaderRow1';
import HeaderRow2 from './HeaderRow2';

import {Container} from 'react-bootstrap';

import './Header.scss';

const Header = props => {
    const pathname = useLocation().pathname;

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <header id="header" className="sticky-top">
            <Container fluid="lg">
                <HeaderRow1 data={props?.data?.contactUs}/>
                {
                    pathname === '/' && (
                        <HeaderRow2/>
                    )
                }
            </Container>
        </header>
    )
}

export default Header;